import { Banner } from '@/components/Banner/Banner';
import { languageStrings } from '@/l18n/de';

const BannerExistingProduct = () => {
	return (
		<Banner className="banner-warning">
			<div className="banner--active-hint">
				<strong>{languageStrings.activeProduct}</strong>

				<a href={`https://${import.meta.env.VITE_APP_DST_ROOT_DOMAIN}`}>{languageStrings.buttons.backToStart}</a>
				{' / '}
				<a href={import.meta.env.VITE_APP_SELF_SERVICE_URL}>{languageStrings.buttons.mySubscriptions}</a>
			</div>
		</Banner>
	);
};

export { BannerExistingProduct };
